//npm packages
import React from "react";
import Select from "react-select";
import ReactSVG from 'react-svg';
import ImageZoom from 'react-medium-image-zoom';
//mui
import Grid from "@material-ui/core/Grid";
import FormHelperText from "@material-ui/core/FormHelperText";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

//pattern
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";

//redux
import { connect } from "react-redux";
import { childAction, saveChild } from "../../../redux/actions/childAction";

//components
import NameInput from "../../Components/PersonalInputs/NameInput";
import DateInput from "../../Components/DateInput";
import DocSeriesInput from "../../Components/DocSeriesInputs/DocSeriesInput";
import DocNumberInput from "../../Components/DocNumberInputs/DocNumberInput";
import RegistrationNumberInput from "../../Components/PersonalInputs/RegistrationNumberInput";
import PersonalIdInput from '../../Components/PersonalInputs/PersonalIdInput';
import UniqueRegisterSeriesInput from '../../Components/UniqueRegisterSeriesInput';

import {saveChildrenScanService} from 'api/api';
//validation is empty (validation)
import { isEmpty } from "../../../validation/is-empty";


//icon
import uploadTable from '../../../components/Icons/download.svg';
import imageLoader from "../../../components/Icons/loading.png";
import attention from "../../../components/Icons/attention.svg";
import Swal from 'sweetalert2';
import EndUser from 'utils/eusign';

// import {destroy} from 'utils/eusign';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000
});
var BASE64_MARKER = ';base64,';
function convertDataURIToBinary(dataURI) {
  var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  var base64 = dataURI.substring(base64Index);
  var raw = window.atob(base64);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));

  for(let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}

const forIssuedBy = /^$|^[0-9А-ЕЖ-ЩЬЮЯа-еж-щьюяЇїІіЄєҐґ' -]+$/;

const customTheme = theme => ({
  ...theme,
  borderRadius: 0,
  minHeight: "35px !important" // squere border-radius
});
const customStyles = {
  //select styles

container: () => ({
    width: "100%",
    height: "35px",
    minHeight: "35px"
  }),
control: base => ({
    ...base,
    height: "35px",
    minHeight: "35px"
  }),
indicatorSeparator: () => ({
    display: "none"
  }),
input: () => ({
    height: "35px",
    minHeight: "35px",
    paddingBootom: "10px"
  }),
valueContainer: base => ({
    ...base,
container: () => ({
      width: "100%"
    })
  }),

indicatorsContainer: base => ({
    ...base,
    height: "35px",
    minHeight: "35px"
  }),
menu: () => ({
    width: "100%",
    backgroundColor: "#fff",
    zIndex: 444,
    border: "1px solid #C2C5CB"
  }),
menuPortal: base => ({
    ...base,
    zIndex: 9999
  }) //- resolve problem with zindex of options
};

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(),
    top: theme.spacing(),
    color: theme.palette.grey[500]
  }
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <>{children}</>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    display: "block",
    height: "auto",
    // width: "100%",
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    // borderTop: `1px solid ${theme.palette.divider}`,
    // margin: 0,
    padding: theme.spacing(),
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      display: "block"
    }
  }
}))(MuiDialogActions);

const styles = {
  // fab: {
  //   margin: theme.spacing(0.5)
  // },
  dialogPaper: {
    // minHeight: '95% !important',
    // maxHeight: '95% !important',
    // minWidth: '90% !important',
    // maxWidth: '90% !important',
    overflow: "visible"
  }
};

class ChildDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // open: false,
      validationText: "",
      displayErrors: false,
      submitted: false,
      imageURI : "",
      fileName:"",
      euSign: null
    };
    this.fileInput = React.createRef();
  }

  // handleClickOpen = () => {
  //   this.setState({
  //     open: true,
  //     validationText: "",
  //     imageURI : ""
  //   });
  //   this.props.clearChildData();
  // };

  handleClose = () => {
    this.props.onClose();
    
    this.setState({ validationText: "", imageURI : "", submitted: false, fileName: "" });
  };

  //handle inputs
  handleInputChildChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'issuedby':
        if (forIssuedBy.test(value)){
          this.props.childAction(name, value.toUpperCase());
        }
        break;
      default:
        this.props.childAction(name, value);
    }
  }

  //handle select
  handleSelectChildChange = name => select => {
    //console.log(name, select.value);
    this.props.childAction(name, select.value);
    if(name === "documenttype" && select.value === 99){
      this.props.childAction("series", "");
    }
  };

  validateRules = [
    {
      name: 'name',
      rule: () => !isEmpty(this.props.child.name)
    },
    {
      name: 'surname',
      rule: () => !isEmpty(this.props.child.surname)
    },
    {
      name: 'bithdaydate',
      rule: () => !isEmpty(this.props.child.bithdaydate) && !this.props.child.bithdaydate.includes('_')
    },
    {
      name: 'gender',
      rule: () => !isEmpty(this.props.child.gender)
    },
    {
      name: 'relation_id',
      rule: () => !isEmpty(this.props.child.relation_id)
    },
    {
      name: 'documenttype',
      rule: () => !isEmpty(this.props.child.documenttype)
    },
    {
      name: 'documentnumber',
      rule: () => !isEmpty(this.props.child.documentnumber) && !this.props.child.documentnumber.includes('_')
    },
    {
      name: 'documentdate',
      rule: () => !isEmpty(this.props.child.documentdate) && !this.props.child.documentdate.includes('_')
    },
    {
      name: 'issuedby',
      rule: () => !isEmpty(this.props.child.issuedby)
    },
    {
      name: 'reg_number',
      rule: () => !isEmpty(this.props.child.reg_number) && !this.props.child.reg_number.includes('_')
    },
    {
      name: 'reg_date',
      rule: () => !isEmpty(this.props.child.reg_date) && !this.props.child.reg_date.includes('_')
    },
    {
      name: 'series',
      rule: () => this.props.child.documenttype !== 3 || (!isEmpty(this.props.child.series) && !this.props.child.series.includes('*'))
    },
    {
      name: 'adopted_date',
      rule: () => ![2, 3].includes(this.props.child.relation_id) || (!isEmpty(this.props.child.adopted_date) && !this.props.child.adopted_date.includes('_'))
    }
  ];

  validateAll = () => {
    for (const { rule } of this.validateRules) {
      if (!rule()) return false;
    }
    return true;
  };

  validate = field => {
    if (!this.state.submitted) return true;
    const validator = this.validateRules.find(({ name }) => name === field);
    return validator ? validator.rule() : false;
  };

  //submit child to server
  submitChild = e => {
    e.preventDefault();

    this.setState({ submitted: true, validationText:"" });

    const dataChild = {
      documenttype: this.props.child.documenttype,
       documentserie: this.props.child.series,
      documentnumber: this.props.child.documentnumber,
       documentissued: this.props.child.documentdate,
      documentissuer: this.props.child.issuedby,
       registernumber: this.props.child.reg_number,
       dregister: this.props.child.reg_date,
       dadopted: this.props.child.adopted_date,
       child_id: this.props.child_id,

      id: this.props.application.id
    };

    // this.props.addChildAction(dataChild);
    this.props.saveChild(dataChild)
    .then(res =>  this.handleClose())
    .catch(err => {});

    
   
    
  };

  deleteImg = () => {
    this.setState({ imageURI:null, fileName: " " });
  }

  buildImgTag() {
    let imgTag = null;
    if (this.state.imageURI !== null)
      imgTag = (<div className="row">
                  <div className="small-9 small-centered columns mt-3">
                    <ImageZoom
                    defaultStyles={{
                      zoomContainer: {
                        zIndex: 1300
                      },
                      overlay: {
                        opacity: .7,
                        backgroundColor: "#000"
                      }
                    }}
                    image={{
                      src: this.state.imageURI,
                      style: {width: '80%', marginTop:"-40px",marginBottom:"20px",margin:"0 auto",display:"block"}
                    }}
                    zoomImage={{
                      src: this.state.imageURI,

                    }}
                    />
                  </div>
                </div>);
    return imgTag;
  }

  readURI(e){
    this.setState({imageURI:"", fileName:""});

    if(e.target.files && e.target.files[0]){
      // console.log("dsfsfsf","dfsfsfd")
      this.setState({fileName:e.target.files[0].name});
      let reader = new FileReader();
      reader.onload = function(ev){
        this.setState({imageURI:ev.target.result});
      }.bind(this);
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  handleChangeFile(e){
    this.readURI(e); // maybe call this with webworker or async library?
    if (this.props.onChange !== undefined)
      this.props.onChange(e); // propagate to parent component
      // console.log("e",e)
  }

  render() {
    const { child, directories, classes, childAction, saveChild, ...other } = this.props;
    const { submitted } = this.state;
    const { validate, handleSelectChildChange, handleInputChildChange } = this;
    // const imgTag = this.buildImgTag();

    return (
      <div className="mr-0 p-0  mr-md-3 mt-3">
      <div className="m-0 p-0 col-12">
        
        </div>
        <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          disableBackdropClick={true}
          open={this.props.open}
          // classes={{ paper: classes.dialogPaper }}
          maxWidth="sm"
          {...other}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={this.handleClose}
          >
            <Typography variant="h4">
            Інформація про дитину:
            </Typography>
           
            <Typography variant="h5" color="error" className="mt-1">
            Увага! 
            </Typography>
            <Typography variant="p" color="error" className="text-center">
            Для свідоцтв про народження, виданих іншими державами серію не вносити, а номер документа допускається до 13 знаків.
            </Typography>
          </DialogTitle>
          <DialogContent>
            {/* <Card  style={{ marginTop: "20px", marginBottom: "0px", paddingBottom: "0px" }}>
              <CardBody className="cardBody "> */}
                <form
                  id="childForm"
                  name="childForm"
                  onSubmit={this.submitChild}
                  noValidate
                >
                <Grid container
                  direction="row"
                  justify="flex-start"
                  alignItems="flex-end"
                  spacing={2}>


                  <Grid item xs={12} sm={6} md={2}>
                    <div className="form-item">
                      <label htmlFor="series">Серія</label>
                      <DocSeriesInput
                        className={validate('series') ? '' : "error"}
                        required
                        name="series"
                        value={child.series}
                        // placeholder="X-XX"
                        doctype={6}
                        onChange={handleInputChildChange}
                        type="text"
                      />
                      {!validate('series') && (
                        <FormHelperText error id="name-error-text">
                          Поле обов'язкове
                        </FormHelperText>
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <div className="form-item">
                      <label htmlFor="documentnumber">Номер</label>
                      <DocNumberInput
                        required
                        name="documentnumber"
                        value={child.documentnumber}
                        doctype={99}
                        // placeholder="XXXXXX"
                        onChange={handleInputChildChange}
                        type="text"
                        className={validate('documentnumber') ? "" : "error"}
                      />
                      {!validate('documentnumber') && (
                        <FormHelperText error id="name-error-text">
                          Поле обов'язкове
                        </FormHelperText>
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={6}>
                    <div className="form-item">
                      <label htmlFor="documentdate">
                        Дата видачі документу
                      </label>
                      <DateInput
                        required
                        value={child.documentdate}
                        onChange={handleInputChildChange}
                        name="documentdate"
                        type="text"
                        className={validate('documentdate') ? '' : "error"}
                      />
                      {!validate('documentdate') && (
                        <FormHelperText error id="name-error-text">
                          Поле обов'язкове
                        </FormHelperText>
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <div className="form-item">
                      <label htmlFor="issuedby">
                        Ким видано документ
                      </label>
                      <input
                        required
                        value={child.issuedby}
                        onChange={handleInputChildChange}
                        name="issuedby"
                        doctype={child.documenttype}
                        type="text"
                        className={validate('issuedby') ? '' : "error"}
                        maxLength="600"
                      />
                      {!validate('issuedby') && (
                        <FormHelperText error id="name-error-text">
                          Поле обов'язкове
                        </FormHelperText>
                      )}
                    </div>
                  </Grid>

                  {parseInt(child.documenttype) === 6 && (
                    <Grid item xs={12} sm={6} md={4}>
                      <div className="form-item">
                        <label htmlFor="unzrNumber">
                          Номер УНЗР
                        </label>
                        <UniqueRegisterSeriesInput
                          name="unzrNumber"
                          value={child.unzrNumber}
                          maxLength={13}
                          type="text"
                          onChange={handleInputChildChange}
                        />
                      </div>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6} md={4}>
                    <div className="form-item">
                      <label htmlFor="reg_number">
                        Номер актового запису
                      </label>
                      <RegistrationNumberInput
                        required
                        // placeholder="XXXXXX"
                        value={child.reg_number}
                        onChange={this.handleInputChildChange}
                        name="reg_number"
                        type="text"
                        className={validate('reg_number') ? '' : "error"}
                      />
                      {!validate('reg_number') && (
                        <FormHelperText error id="name-error-text">
                          Поле обов'язкове
                        </FormHelperText>
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <div className="form-item">
                      <label htmlFor="reg_date">
                        Дата актового запису
                      </label>
                      <DateInput
                        required
                        // placeholder="DD.MM.YYYY"
                        value={child.reg_date}
                        onChange={handleInputChildChange}
                        name="reg_date"
                        type="text"
                        className={validate('reg_date') ? '' : "error"}
                      />
                      {!validate('reg_date') && (
                        <FormHelperText error id="name-error-text">
                          Поле обов'язкове
                        </FormHelperText>
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <div className="form-item">
                      <label htmlFor="adopted_date">
                        Дата встановлення опіки(піклування)
                      </label>
                      <DateInput
                        required
                        // placeholder="DD.MM.YYYY"
                        value={child.adopted_date}
                        onChange={handleInputChildChange}
                        name="adopted_date"
                        type="text"
                        className={validate('adopted_date') ? '' : "error"}
                      />
                      {!validate('adopted_date') && (
                        <FormHelperText error id="name-error-text">
                          Поле обов'язкове
                        </FormHelperText>
                      )}
                    </div>
                  </Grid>

                </Grid>
              </form>
            {/* </CardBody>
          </Card> */}
        {/* <form
          className="mb-3 pl-4 mt-1 p-0 pr-4 text-center"
          id="childForm"
          name="childForm"
          noValidate
          onSubmit={this.submitChild}
        >
            {submitted && !this.state.imageURI && (<FormHelperText style={{textAlign:"center", marginTop:"15px"}}error id="name-error-text">
                Наявність копії документу - обов'язкова
            </FormHelperText>)}
          <div  style={{width:"20%", margin: "20px auto 10px"}}>{this.state.fileName}</div>
          <div className="mb-2">
         <ReactSVG
                      svgStyle={{
                      display: "inline-block",
                      height: 33,
                      }}
                      src={attention}
                      width="50"
                    />
           <div style={{ display: "inline-block", textAlign:"center" }} >Увага! Необхідно накласти КЕП на сканований документ!</div>
           <div style={{ display: "inline-block", textAlign:"center" }} >Увага! Розмір документу для завантаження не повинен перевищувати 6 МB</div>
          </div>
            <label htmlFor="file-uploadChild" className="custom-file-upload ml-1 btn100 mr-3 ">
            <div style={{margin:"0 auto", textAlign:"center"}}>
                <div style={{ display: "inline-block", textAlign:"center" }}>
                    <ReactSVG
                      svgStyle={{
                      display: "inline-block",
                      height: 33,
                      }}
                      src={uploadTable}
                      width="50"
                    />
                  </div>
                  <div style={{ display: "inline-block", textAlign:"center" }}> ОБЕРІТЬ ФАЙЛ</div>

                  </div>
               </label>
            <input
            id="file-uploadChild"
            className="upload"
            type="file"
            accept='.jpeg,.jpg,.png,.pdf'
            ref={this.fileInput}
            onChange={this.handleChangeFile.bind(this)}
            />
          </form> */}
          </DialogContent>
          <DialogActions style={{borderTop:"none !important"}}>
            <div
                  className={
                    this.state.validationText.length < 20
                      ? "okFormSubmit"
                      : "errorFormSubmit"
                  }
                >
                 {submitted && !this.state.displayErrors &&
                 (<React.Fragment>
                 <div className="w-100">Відправка форми </div>
                 <div><i className="winphone-2-128x6" style={{ backgroundImage: `url(${imageLoader})` }} /></div>
                  </React.Fragment>)}
                  {this.state.validationText}
            </div>
          </DialogActions>
          <DialogActions>
            <form
              id="childForm"
              name="childForm"
              onSubmit={this.submitChild}
              noValidate
            >
              <Button
                color="primary"
                className="ml-2 mr-2 btn100"
                // onClick={this.handleSubmitChildInfo}
                type="submit"
              >
                Зберегти
              </Button>

            <Button
              className="ml-2 btn100"
              onClick={this.handleClose}
              color="primary"
            >
              Відмінити
            </Button>
            </form>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    child: state.child,
    directories: state.directories,
    applicant: state.applicant,
    application: state.application,
    applications: state.application.applications,
    //euSign: state.eusign.eusign
  };
};

export default connect(
  mapStateToProps,
  {
    // getChildrenData,
    childAction,
    // requestDataforSelectStatement,
    // clearChildData,
    // addChildAction,
    saveChild,
    // apllicantData
  }
)(withStyles(styles)(ChildDialog));
